<template>
  <div
    id="header"
    style="display: flex;"
    :style="{
      background: isDarkTheme ? topBgColor : bgTheme,
      top: statusBarHeaderTop,
      borderBottomLeftRadius: '20px',
      borderBottomRightRadius: '20px'
    }"
  >
    <div
      style="padding-left: 10px;"
      class="header-wrapper text-light full-width"
    >
      <div class="align-hor center-ver">
        <div>
          <!-- <img
            class="medium-icon pull-left margin-10 pointer"
            src="@/assets/back-light.png"
            v-if="showBackButton"
            v-on:click="back"
          /> -->
          <back-icon v-if="backButtonVisible" @click="back" />
        </div>
        <div
          :style="{
            color: isDarkTheme ? headingTextColor : '#ffffff',
            paddingLeft: '5px',
            // marginBottom: '5px',
            fontSize: '18px'
          }"
          class="text-left text-large"
          :class="[showBackButton ? 'padding-10' : 'padding-vertical-10']"
        >
          {{ getTranslatedText(headerTitle) }}
        </div>
      </div>

      <div
        v-if="headerTitle === 'Gift Cards'"
        style="background-color: #ffffff; color: black; padding: 5px 20px; display: flex; justify-content: center; align-items: center; gap: 5px; border-radius: 15px;"
        class="gift-balance"
      >
        <img
          style="width: 15px;"
          :src="activeCurrency.icon_url"
          alt="Gift Card"
        />
        <span style="font-size: 12px;"
          >{{ giftCardBalance.balance }} {{ giftCardBalance.reward_type }}</span
        >
      </div>

      <div class="tickets align-hor center-ver margin-right-10">
        <!-- <div
          v-if="showWallet"
          :class="[showHistory ? 'margin-right-30' : '']"
          v-on:click="enableWalletClick ? redirectTo('wallet', '') : ''"
        >
          <div class="container">
            <img class="large-icon" src="@/assets/ticket-white.svg" />
            <div class="text-small centered text-grey">
              {{ totalUserPointsEarned }}
            </div>
          </div>
          <p class="text-uppercase text-semi-small no-margin" v-if="walletType">
            {{ getTranslatedText(walletType) }}
          </p>
          <div class="wrapper" v-else>
            <div
              class="comment animate green text-uppercase text-semi-small no-margin"
              :style="`--bgcolor: ${bgTheme}`"
            ></div>
          </div>
        </div> -->
        <div v-if="showHistory" v-on:click="redirectTo('history', '')">
          <img class="reward-icon" src="@/assets/history.svg" />
        </div>
        <div
          v-if="userHeaderBalance.show && userHeaderBalance.balance > 0"
          class="credit align-ver center-ver"
        >
          <div
            class="wrap padding-5 radius-30 bg-light align-hor center-ver center-hor"
          >
            <img
              class="smaller-icon pull-left margin-right-5"
              :src="userHeaderBalance.icon"
            />
            <span class="text-grey margin-right-5 align-hor center-ver">{{
              userHeaderBalance.balance
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showWallet" class="close-sdk-btn" @click="closeClick">
      <!-- <svg
        width="40"
        height="40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="40" height="40" rx="12" fill-opacity="0.19"></rect>
        <path
          d="m14 26 12-12m0 12L14 14"
          stroke="#fff"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></path>
      </svg> -->
      <!-- × -->
    </div>
  </div>
</template>

<script>
import { globals } from "@/mixins/globals";
import BackIcon from "@/components/back-icon.vue";
export default {
  name: "custom-header",
  mixins: [globals],
  components: {
    BackIcon
  },
  data() {
    return {};
  },
  computed: {
    isDarkTheme() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.isDarkTheme &&
        this.$store.state.sdkEvent.isDarkTheme
      ) {
        return this.$store.state.sdkEvent.isDarkTheme;
      }
      return null; // fallback
    },
    headingTextColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.headingTextColor
      ) {
        return this.$store.state.sdkEvent.themeColors.headingTextColor;
      }
      return null; // fallback
    },
    topBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.topBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.topBgColor;
      }
      return null; // fallback
    },

    activeCurrency() {
      return this.$store.getters.getActiveCurrency;
    },

    computedUserBalances() {
      return this.userBalances.filter(item => item.reward_type !== "Stamps");
    },

    giftCardBalance() {
      // 🔑 Match activeCurrency.label (case-insensitive) with reward_type
      const giftCard = this.computedUserBalances.find(
        item =>
          item.reward_type &&
          item.reward_type.toLowerCase() ===
            this.activeCurrency.label.toLowerCase()
      );

      console.log("Gift Card Balance:", giftCard ? giftCard.balance : 0);
      console.log("Gift Card Icon:", giftCard ? giftCard.reward_icon : "");
      console.log("Matched Gift Card Object:", giftCard);

      return giftCard
        ? giftCard
        : {
            balance: 0,
            total_earned: 0,
            total_redeemed: 0,
            reward_type: this.activeCurrency.label,
            reward_icon: this.activeCurrency.icon_url,
            transactions_count: 0,
            transactions: null
          };
    }
  },
  methods: {
    redirectToHistory() {
      var path = "history";
      var params = {
        partner: self.partnerID,
        phone: self.userPhone
      };
      this.redirectTo(path, params);
    },
    closeClick() {
      window.parent.postMessage("close-sdk", "*");
      // if (window.webkit) {
      //   window.webkit.messageHandlers.handleMessage.postMessage('close-sdk');
      // } else {

      // }
    }
  }
};
</script>

<style>
#header {
  position: fixed;
  top: 0;
  display: block;
  left: 0;
  right: 0;
  z-index: 1;
  /* border-bottom: 1px solid #cccccc; */
  height: 64px;
}
.header-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.header-block {
  flex: 1;
}
.full-height {
  height: 100%;
}
.title {
  font-size: 18px;
}
.rewards {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.reward-icon {
  width: 40px;
}
.cash,
.token,
.rewards {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.rewards-count {
  bottom: 10px;
  left: 10px;
  padding: 2px;
  min-height: 25px;
  height: auto;
  min-width: 25px;
  width: auto;
}
.count {
  font-size: 12px;
}
.close-sdk-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  padding: 10px;
  cursor: pointer;
  font-size: 18px;
}

/* Very small phones (iPhone SE, older Android) */
@media (max-width: 360px) {
  .gift-balance {
    position: relative;
    left: 20px;
  }
}

/* Normal mobiles (iPhone 12/13/14/15, Samsung A/M series) */
@media (min-width: 361px) and (max-width: 480px) {
  .gift-balance {
    position: relative;
    left: 50px;
  }
}
</style>
